$("input#notify").on("focus input", function (e) {
	$("#notify").removeClass("form_error_bb");
});

$(".notify_submit").on("click", function (e) {
	e.preventDefault();
	const email = $("#notify").val();
	const eReg = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g.test(email);
	const kListId = $('input[name="k_list_id"]').val();
	const kPublicKey = $('input[name="k_public_key"]').val();
	const newsletterConsent = $("#newsletter-consent").is(":checked");
	const productVariant = $('input[name="id"]').val();

	if (eReg !== true) {
		$(".email_error").removeClass("none");
		$("#notify").addClass("form_error_bb");
		throw new Error("Invalid Email Entry");
	}
	subscribeUser(email, newsletterConsent, productVariant, kListId);
	backInStock(email, productVariant, kPublicKey);
});

function subscribeUser(userEmail, consent, variant, listId) {
	$.ajax({
		async: true,
		crossDomain: true,
		type: "POST",
		headers: {
			"content-type": "application/x-www-form-urlencoded",
			"cache-control": "no-cache",
		},
		url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
		data: {
			g: listId, // list id
			$fields: "$source,$variant,$method_type,$method_id,$newsletter_consent",
			email: userEmail, // user email
			$source: "Shopify - Product",
			$variant: variant, // product variant
			$method_type: "Klaviyo Product Embed",
			$method_id: "notify-me",
			$newsletter_consent: consent,
		},
	})
		.done(function (response) {
			$("#product-notification").removeClass("none");
			$(".product_notification_error").attr("style", "display: none");
			console.log(`SUCCESS: User Subscribed: ${userEmail}`);
			console.log(`subscribeUser()`, response);
		})
		.fail(function (error) {
			console.log(`subscribeUser()`, error);
			$(".product_notification_error").attr("style", "display: block");
			console.log(`ERROR: Subscribing user ${userEmail} \n ${error}`);
		});
}

function backInStock(userEmail, variant, klaviyoKey) {
	$.ajax({
		async: true,
		crossDomain: true,
		type: "POST",
		url: "https://a.klaviyo.com/onsite/components/back-in-stock/subscribe",
		data: {
			a: klaviyoKey, //  public key
			email: userEmail, // user email
			variant: variant, // variant
			platform: "shopify",
		},
	})
		.done(function (response) {
			$(".pn_v").attr("style", "display: none");
			$(".product_notification_success").attr("style", "display: block");
			$(".product_notification_error").attr("style", "display: none");

			console.log(`SUCCESS: backInStock() ${userEmail}, ${variant}`);
			console.log(response);
		})
		.fail(function (error) {
			$(".product_notification_error").attr("style", "display: block");
			console.log(`ERROR: Back In Stock ${userEmail}, ${variant}`);
			console.log(error);
		});
}
